import { render, staticRenderFns } from "./Upgrade.vue?vue&type=template&id=db2bc4c2&scoped=true&"
import script from "./Upgrade.vue?vue&type=script&lang=js&"
export * from "./Upgrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2bc4c2",
  null
  
)

export default component.exports